var _defs, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Gradiente_sem_nome_192);\n      }\n\n      .st1 {\n        fill: url(#Gradiente_sem_nome_19);\n      }\n\n      .st2 {\n        fill: url(#Gradiente_sem_nome_191);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_19",
    "data-name": "Gradiente sem nome 19",
    x1: -0.21,
    y1: 243.11,
    x2: 504.79,
    y2: 239.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0072fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_191",
    "data-name": "Gradiente sem nome 19",
    x1: 0.29,
    y1: 305.99,
    x2: 505.29,
    y2: 301.99,
    xlinkHref: "#Gradiente_sem_nome_19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_192",
    "data-name": "Gradiente sem nome 19",
    x1: 0.31,
    y1: 308.5,
    x2: 505.31,
    y2: 304.5,
    xlinkHref: "#Gradiente_sem_nome_19"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M474.11,226.3c-58.37-15.36-94.21-13.31-102.4-16.38-4.1-1.02,0,0-62.46-37.89-6.14-4.1-14.34-6.14-21.5-7.17-70.66-8.19-153.6-6.14-209.92,37.89-3.07,2.05-5.12,4.1-8.19,4.1l-32.77,10.24c-6.14,2.05-11.26,6.14-13.31,11.26-11.26,19.46-15.36,44.03-9.22,66.56,2.05,9.22,9.22,15.36,17.41,17.41l8.19,2.05c0-3.07-1.02-5.12-1.02-8.19,0-36.86,29.7-66.56,66.56-66.56s66.56,29.7,66.56,66.56c0,5.12-1.02,10.24-2.05,14.34h187.39c-1.02-5.12-2.05-9.22-2.05-14.34,0-36.86,29.7-66.56,66.56-66.56s66.56,29.7,66.56,66.56c0,4.1,0,8.19-1.02,12.29,8.19-4.1,13.31-13.31,13.31-22.53v-31.74c1.02-18.43-10.24-33.79-26.62-37.89ZM173.06,225.28c-3.07,0-6.14-1.02-8.19-4.1l-24.58-29.7c22.53-7.17,49.15-11.26,78.85-11.26l12.29,45.06h-58.37ZM340.99,224.26c-2.05,1.02-3.07,1.02-5.12,1.02h-82.94l-12.29-44.03c14.34,1.02,28.67,2.05,43.01,3.07,4.1,0,9.22,2.05,13.31,4.1l50.18,30.72-6.14,5.12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 105.47,
    cy: 305.15,
    r: 46.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 422.91,
    cy: 305.15,
    r: 46.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.31a47267c327e7aea50a0d47ce13ebb1.svg";
export { ForwardRef as ReactComponent };